import {
  sortCurriculumTypesWithKFirst,
  getRelevantCourseList,
} from 'experienceComponents/CreateInstanceShared/dataUtils'
import {
  filterSmallGroupCurriculumTypes,
  convertGradeToDisplayValue,
  convertGradeNameToLabel,
  getProgramName,
  getInstructorResponseKeyForCurriculumType,
  getTier2CourseCodeFromCurriculumType,
  createViewClassBehavior,
} from './data'

// Filter and sort configuration
export const smallGroupFilterConfig = {
  filterFunction: filterSmallGroupCurriculumTypes,
  sortFunction: sortCurriculumTypesWithKFirst,
  getRelevantCourseList: courses => getRelevantCourseList(courses, true), // true = small groups
  convertGradeToDisplayValue: convertGradeToDisplayValue,
  isSmallGroup: true, // Explicit flag - don't rely on function name matching
}

// Program mapping configuration
export const smallGroupProgramConfig = {
  convertGradeNameToLabel: convertGradeNameToLabel,
  getProgramName: getProgramName,
}

export const smallGroupCourseCentricProgramConfig = {
  convertGradeNameToLabel,
  getProgramName,
  getContentGroupCode: curriculumType => getProgramName(curriculumType),
  getCourseCodeFromGradeLabel: curriculumType =>
    getTier2CourseCodeFromCurriculumType(curriculumType),
  getInstructorResponseKey: curriculumType =>
    getInstructorResponseKeyForCurriculumType(curriculumType),
}

// View class behavior configuration
export const smallGroupViewClassConfig = {
  createViewClassBehavior: createViewClassBehavior,
}

// Legacy config for backward compatibility
export const smallGroupConfig = {
  ...smallGroupFilterConfig,
  ...smallGroupProgramConfig,
  ...smallGroupViewClassConfig,
}
